(() => {
  function initialize(root = document) {
    root.querySelectorAll('[data-rk-portrait-guide]').forEach(guide => {
      if (guide.dataset.rkGuideReady === 'true') return;
      guide.open = window.matchMedia('(min-width: 768px)').matches;
      guide.dataset.rkGuideReady = 'true';
    });
    root.querySelectorAll('[data-rk-product-tabs]').forEach(group => {
      if (group.dataset.rkTabsReady === 'true') return;
      const tabs = Array.from(group.querySelectorAll('[data-rk-tab]'));
      const panels = Array.from(group.querySelectorAll('[data-rk-panel]'));
      if (tabs.length !== 2 || panels.length !== 2) return;
      const reviews = document.getElementById('rkProductReviews');
      const mount = group.querySelector('[data-rk-review-mount]');
      if (reviews && mount && !group.contains(reviews)) mount.replaceChildren(reviews);
      group.dataset.rkTabsReady = 'true';
      function select(name, focus = false) {
        tabs.forEach(tab => {
          const active = tab.dataset.rkTab === name;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          tab.classList.toggle('is-active', active);
          if (active && focus) tab.focus();
        });
        panels.forEach(panel => {
          const active = panel.dataset.rkPanel === name;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
        });
      }
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(tab.dataset.rkTab));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          select(tabs[next].dataset.rkTab, true);
        });
      });
      function revealReviewAnchor() {
        if (['#rkMasonryReviews', '#rkProductReviews'].includes(location.hash)) select('reviews');
      }
      document.addEventListener('click', event => {
        if (event.target.closest('a[href="#rkMasonryReviews"], a[href="#rkProductReviews"]')) select('reviews');
      });
      window.addEventListener('hashchange', revealReviewAnchor);
      select('reviews');
      revealReviewAnchor();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', () => initialize());
})();
